import type { RealestateAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { convertCurrency } from "../genericCalculations/convertCurrency";
import { calculateRealestateTotalPerYear } from "./totalPerYear";

export const calculateRealestateTotalExpenses = (
  userProduct: RealestateAsset,
  baseCurrency: Fiat,
  currentCurrency: Fiat
) => {
  const totalsPerYear = calculateRealestateTotalPerYear(userProduct);

  const totalExpenses = totalsPerYear?.reduce((sum, current) => {
    return sum + current;
  }, 0);

  return convertCurrency(totalExpenses, baseCurrency, currentCurrency); // TODO: check if needed.
};
